<div class="notifications" [ngClass]="{ visible: isOutOfOffice && isLoggedIn }">
  <span>You are currently marked as Out of Office. To update your availability, </span>
  <button
    type="button"
    class="hyperlink"
    (click)="openOutOfOfficeModal(editProfile)"
    (keyup.enter)="openOutOfOfficeModal(editProfile)"
    (keyup.space)="openOutOfOfficeModal(editProfile)"
  >
    navigate to Update Profile.
  </button>
</div>

<!-- Define the modal template here -->
<ng-template #editProfile let-modal>
  <th-edit-my-profile defaultTab="ooo"></th-edit-my-profile>
</ng-template>
